import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterAfhaalBezorgPage() {
  return <ClusterPageTemplate clusterName="Afhaal & Bezorg" sectorName="Horeca & Hospitality" sectorSlug="horeca-hospitality" heroTitle="Website laten maken voor afhaal en bezorging" heroDescription="Een snelle, conversiegerichte website voor jouw bezorgrestaurant of afhaalzaak. Wij bouwen websites die hongerige bezoekers direct aanzetten tot bestellen." websiteOnderdelen={[{
    icon: 'ShoppingCartIcon',
    title: 'Bestelmenu',
    description: "Een visueel aantrekkelijk menu met duidelijke categorieën, foto's en prijzen."
  }, {
    icon: 'MapPinIcon',
    title: 'Bezorggebied',
    description: 'Heldere communicatie over waar jullie bezorgen, bezorgkosten en minimale bestelbedragen.'
  }, {
    icon: 'StoreIcon',
    title: 'Afhaalinformatie',
    description: 'Duidelijke adresgegevens, openingstijden en parkeerinformatie voor afhalers.'
  }, {
    icon: 'StarIcon',
    title: 'Acties & Aanbiedingen',
    description: 'Een opvallende sectie voor daghappen, combi-deals of kortingscodes om meer te verkopen.'
  }]} functionaliteiten={[{
    icon: 'ShoppingCartIcon',
    title: 'Bestelsysteem integratie',
    description: 'Naadloze koppeling met systemen zoals Thuisbezorgd, UberEats, Sitedish of CashDesk.'
  }, {
    icon: 'PhoneIcon',
    title: 'Click-to-call',
    description: 'Een grote bel-knop op mobiel voor klanten die liever telefonisch hun bestelling doorgeven.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: "Optimalisatie voor zoektermen als 'pizza bestellen [jouw stad]' of 'sushi afhalen'."
  }]} siblingClusters={[{
    name: 'Restaurant',
    slug: 'restaurant'
  }, {
    name: 'Hotel & B&B',
    slug: 'hotel-bb'
  }, {
    name: 'Café & Lunchroom',
    slug: 'cafe-lunchroom'
  }]} faqs={[{
    q: 'Bouwen jullie een eigen bestelsysteem of koppelen jullie?',
    a: 'Meestal koppelen we de website aan gespecialiseerde bestelsystemen (zoals Sitedish of CashDesk) omdat deze direct in verbinding staan met je kassasysteem en bonnenprinter.'
  }, {
    q: 'Hoe zorg ik dat mensen via mijn site bestellen i.p.v. Thuisbezorgd?',
    a: 'We maken de bestelknop naar jouw eigen systeem (waar je minder commissie betaalt) het meest prominent, en kunnen acties communiceren die alleen gelden via je eigen site.'
  }, {
    q: 'Wat kost een website voor een bezorgrestaurant?',
    a: 'Een snelle, lokaal vindbare website start vanaf €1.500. Dit is inclusief de integratie van de bestelknoppen naar jouw gekozen bestelplatform.'
  }, {
    q: 'Is de website snel genoeg op mobiel?',
    a: 'Ja, snelheid is cruciaal voor bezorgrestaurants. Wij bouwen extreem snelle websites zodat hongerige klanten niet afhaken door een trage laadtijd.'
  }]} data-id="element-1063" data-mp="3lrb0yq6lhzdx" />;
}